import type { ChannelFeedArtifact } from "@mlx/contracts";

import { linkEntity } from "@/components/content/link-entity";
import { canvasLinks, type RunArtifact } from "@/lib/run-artifacts";

export function channelFeedRunArtifact(
  value: ChannelFeedArtifact,
): RunArtifact | null {
  if (value.kind === "external-resource" && value.href)
    return {
      id: value.id,
      runId: value.sourceRunId,
      sessionId: value.sourceSessionId,
      title: value.title,
      // What the link is ("Google Doc", "HubSpot deal") when its address says.
      kindLabel: linkEntity(value.href)?.kind ?? "Link",
      href: value.href,
      operation: value.operation,
    };
  if (value.provider === "mlx" && value.kind === "html")
    return {
      ...canvasLinks(value.id),
      id: value.id,
      runId: value.sourceRunId,
      sessionId: value.sourceSessionId,
      title: value.title,
      kindLabel: "Canvas",
      version: value.version,
      operation: value.operation,
      currentVersionId: value.versionId,
      contentKind: "html",
    };
  if (
    value.provider !== "mlx" ||
    (value.kind !== "markdown" && value.kind !== "csv")
  )
    return null;
  const contentHref = `/api/artifacts/${encodeURIComponent(value.id)}/content?versionId=${encodeURIComponent(value.versionId)}`;
  return {
    id: value.id,
    runId: value.sourceRunId,
    sessionId: value.sourceSessionId,
    title: value.title,
    kindLabel: value.kind === "csv" ? "Spreadsheet" : "Document",
    version: value.version,
    operation: value.operation,
    currentVersionId: value.versionId,
    contentHref,
    downloadHref: `${contentHref}&download=1`,
    contentKind: value.kind,
    ...(value.kind === "markdown"
      ? {
          pdfHref: `/api/artifacts/${encodeURIComponent(value.id)}/pdf?versionId=${encodeURIComponent(value.versionId)}`,
        }
      : {}),
  };
}
